import React from 'react';
import './ServiceGrid.css';
import { orderedServiceLangs } from '../utils/serviceNameLangs';
import { libelleEcran } from '../utils/serviceCode';

/**
 * ServiceGrid — disposition « grille » de l'écran /display (config.display.layout === 'grid').
 *
 * Présentationnel PUR : affiche une grille des services avec le nombre de personnes
 * EN ATTENTE par service. Remplace l'ancienne page/route séparée `/display-grid` :
 * c'est désormais un simple MODE de DisplayScreen, activable depuis la console admin.
 *
 * @author Dr Hamid MADANI <drmdh@msn.com>
 */
const SERVICE_ICONS = { P: '👔', C: '💰', S: '🔧', A: '📡' };

const ServiceGrid = ({ config, waitingCounts = {} }) => {
  const styles = config?.styles?.display || {};
  // « en attente » suit les MÊMES langues et le même ordre que les noms de service : un écran
  // qui nomme le service en arabe puis en français ne peut pas conclure en français seulement.
  const langues = orderedServiceLangs(styles, 'x');
  return (
    <div className="service-grid-mode">
      <div className="services-grid">
        {config?.serviceTypes?.map((service) => (
          <div key={service.id} className="service-grid-card">
            <div className="service-grid-header">
              <div className="service-grid-icon">{SERVICE_ICONS[service.id] || '🎫'}</div>
              {/* Ordre / visibilité / taille des langues : pilotés depuis la console (Styles). */}
              {orderedServiceLangs(styles, 'service-grid-name').map((l) => {
                const t = l.text(service);
                return t ? <div key={l.key} className={l.cls} dir={l.dir}>{t}</div> : null;
              })}
            </div>
            <div className="service-grid-count">{waitingCounts[service.id] || 0}</div>
            {langues.map((l) => (
              <div key={l.key} className="service-grid-label" dir={l.dir}>
                {libelleEcran(config, 'waiting', l.key)}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceGrid;
